import React from 'react';
import { Alert } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';

/**
 * DryRunBanner — shown on every page that could imply destructive action. Makes the
 * safety posture unmistakable: nothing here deletes real cross-service data.
 */
export const DryRunBanner: React.FC<{ message?: string; className?: string }> = ({
  message,
  className,
}) => (
  <Alert
    className={className}
    type="info"
    showIcon
    icon={<SafetyOutlined />}
    message="Destructive retention enforcement is disabled — current mode: DRY-RUN ONLY"
    description={
      message ??
      'Retention and cross-service erasure are preview-only. The only action that executes is compliance-service-owned anonymization. No employee, payroll, leave, or document data is modified.'
    }
    style={{ marginBottom: 16 }}
  />
);

export default DryRunBanner;
